import { Input } from '@/components/ui/input';
import useTranslation from '@/hooks/i18n';
import { useMissionListingStore } from '../../store/useMissionListingStore';
import { useDebounce } from '@/hooks/useDebounce';
import { ProgrammeFilterComponent } from '../programme-filter';
import { Checkbox } from '@/components/Checkbox';

export const MissionSearch = () => {
  const { t } = useTranslation();
  const filters = useMissionListingStore((state) => state.filters);
  const missionListPage = useMissionListingStore((state) => state.missionListPage);
  const updateFilters = useMissionListingStore((state) => state.updateFilters);
  const handleToggleFilter = useMissionListingStore((state) => state.handleToggleFilter);
  const searchSection = missionListPage?.searchSection;
  const { value: searchTerm, onChangeValue: onChangeSearchTerm } = useDebounce(
    (text: string) => updateFilters({ ...filters, searchTerm: text }),
    500,
    filters.searchTerm,
  );

  return (
    <div className="mt-sh-30 rounded-[16px] border border-primary-500 p-[16px]">
      <h2 className="font-cadiz text-sh-28-32 font-bold">{searchSection?.title}</h2>

      <ProgrammeFilterComponent />

      <div className="mt-4 flex flex-col gap-4">
        <Input
          label={searchSection?.roleModelTitle}
          placeholder={searchSection?.roleModelPlaceholder}
          value={searchTerm}
          onChange={(e) => onChangeSearchTerm(e.target.value)}
          className="w-full"
          showSearchIcon
        />

        <div>
          <p className="mb-2 font-cadiz text-sh-xs font-bold">{searchSection?.keyStageTitle}</p>
          <div className="flex max-w-[700px] flex-wrap">
            {searchSection?.keyStages?.map((keyStageItem) => {
              const keyStage = keyStageItem?.keyStage;
              if (!keyStage) return null;
              return (
                <Checkbox
                  key={keyStage}
                  checked={filters.keyStages?.includes(keyStage) || false}
                  onCheckedChange={() => handleToggleFilter('keyStages', keyStage)}
                  label={keyStage}
                />
              );
            })}
          </div>
        </div>

        <div>
          <p className="mb-2 font-cadiz text-sh-xs font-bold">{searchSection?.characterTraitTitle}</p>
          <div className="flex max-w-[700px] flex-wrap">
            {searchSection?.traits?.map((traitItem) => {
              const trait = traitItem?.trait;
              if (!trait) return null;
              return (
                <Checkbox
                  key={trait}
                  checked={filters.characterTraits?.includes(trait) || false}
                  onCheckedChange={() => handleToggleFilter('characterTraits', trait)}
                  label={t(trait)}
                />
              );
            })}
          </div>
        </div>

        {/* <div>
          <p className="mb-2 font-cadiz text-sh-xs font-bold">{searchSection?.locationTitle}</p>
          <div className="flex flex-wrap">
            {searchSection?.locations?.map((locationItem) => {
              const location = locationItem?.location;
              if (!location) return null;
              return (
                <Checkbox
                  key={location}
                  checked={filters.locations?.includes(location) || false}
                  onCheckedChange={() => handleToggleFilter('locations', location)}
                  label={t(location)}
                />
              );
            })}
          </div>
        </div> */}
      </div>
    </div>
  );
};
